module.exports = __webpack_public_path__ + "static/media/reshenie_logo.80a76066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reshenie_logo.png
// module id = 322
// module chunks = 0